import { z } from 'zod'
import {
  confirmPasswordValidationSchema,
  newPasswordValidationSchema,
} from '~/@pages_account-settings/password/change-password-form/changePasswordSchema'
import { validatePassword } from '~/@lib/utils/password.utils'

export const resetPasswordSchema = z
  .object({
    password: newPasswordValidationSchema('Zadajte nové heslo'),
    confirmPassword: confirmPasswordValidationSchema('Potvrďte nové heslo'),
  })
  .refine(
    (data) => {
      const error = validatePassword(data.confirmPassword, data.password)
      return error === null
    },
    {
      message: 'Heslá sa nezhodujú',
      path: ['confirmPassword'],
    }
  )

export type ResetPasswordSchema = z.infer<typeof resetPasswordSchema>
